import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { login } from '../utils/api';
import { mapErrorMessage } from '../utils/errorMapping';
import './Login.css';

const Login = ({ setToken, setTimezone, onSchoolSelect }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            const result = await login(email, password);
            onSchoolSelect(result.data, email, password);
        } catch (error) {
            setError(mapErrorMessage(error.message));
        }
    };

    return (
        <div>
        <div className="lp-topbar">
            <Link to="/" className="lp-logo lp-logo-pointer"><div className="lp-logo"><img src="/logo.png" alt="aistCRM" className="logo-img" /></div></Link>
        </div>
        <div className="login-container">
            <form onSubmit={handleLogin} className="login-form">
                {error && <p className="error">{error}</p>}
                <input
                    type="email"
                    placeholder="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                />
                <input
                    type={showPassword ? 'text' : 'password'}
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                />
                <a href="#" onClick={() => setShowPassword(!showPassword)} className="show-password-link">
                    {showPassword ? 'Hide' : 'Show'} password
                </a>
                <button type="submit">Login</button>
                <Link to="/forgot-password" className="register-link">
                    Forgot password?
                </Link>
                <p className="login-link">
                    Don't have an account? <Link to="/register" className="register-link">Register</Link>
                </p>
            </form>
        </div>
        </div>
    );
};

export default Login;